import React, {
  useState, Fragment, useEffect,
} from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import './style.scss';
import { Select } from 'antd';
import CurrenciesActions from '@Actions/configurations/currenciesAction';
import H3FormInput from '@Uilib/h3FormInput';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import PRZSelect from '../../../../Common/UI/PRZSelect';
/**
 * PaymentTermForm component
 *
 * @param file
 */
const { Option } = Select;
const CurrenciesForm = ({
  currencies, oldCurrencies, selectedCurrencyUpdate, updateCurrenciesLoading, createCurrenciesLoading, createCurrencies, updateCurrencies, callback,

}) => {

  const [formSubmitted, setFormSubmitted] = useState(false);
  const [selectedCurrency, setSelectedCurrency] = useState(null);
  const [ConversionRate, setConversionRate] = useState(null);

  useEffect(() => {
    if (selectedCurrencyUpdate) {
      setSelectedCurrency(`${selectedCurrencyUpdate?.currency_code} (${selectedCurrencyUpdate?.currency_symbol})`);
      setConversionRate(selectedCurrencyUpdate?.conversion_rate);
    }
  }, [selectedCurrencyUpdate]);

  const currencyOptions = Object.values(currencies || {}).map((currency) => ({
    label: `${currency.country} - ${currency.currency_code} (${currency.currency_symbol})`,
    value: JSON.stringify(currency),
    disabled: oldCurrencies?.includes(currency?.currency_code),
  }));
  const handleCurrencyChange = (value) => {
    setSelectedCurrency(JSON.parse(value));
  };

  const CreateCurrencies = () => {
    setFormSubmitted(true);
    const payload = {
      country: selectedCurrency.country,
      currency_code: selectedCurrency.currency_code,
      currency_symbol: selectedCurrency.currency_symbol,
      is_default: false,
      conversion_rate: ConversionRate,
      automatic_conversion_rate: selectedCurrency?.currency_conversion_rate,
    };
    if (selectedCurrency?.currency_code && ConversionRate) {
      createCurrencies(payload, () => {
        setSelectedCurrency(null);
        setConversionRate(null);
        setFormSubmitted(false);
        callback();
      });
    }
  };
  const UpdateCurrencies = () => {
    setFormSubmitted(true);
    const payload = {
      org_currency_id: selectedCurrencyUpdate?.org_currency_id,
      country: selectedCurrencyUpdate?.country,
      currency_code: selectedCurrencyUpdate?.currency_code,
      currency_symbol: selectedCurrencyUpdate?.currency_symbol,
      is_default: false,
      conversion_rate: ConversionRate,
    };
    if (ConversionRate) {
      updateCurrencies(payload, () => {
        setSelectedCurrency(null);
        setConversionRate(null);
        setFormSubmitted(false);
        callback();
      });
    }
  };

  const CurrencyValue = () => {
    if (selectedCurrencyUpdate) {
      return selectedCurrency; // Return the object
    }
    return selectedCurrency ? JSON.stringify(selectedCurrency) : ''; // Return the string or an empty string
  };

  return (
    <Fragment>
      <div className="ant-row">
        <div className="ant-col-md-24">
          <div className="orgInputContainer">
            <label className="orgFormLabel">
              Select Currency
              <span style={{ color: 'red', marginLeft: '5px' }}>*</span>
            </label>
            <PRZSelect
              filterOption
              showSearch
              onChange={handleCurrencyChange}
              value={CurrencyValue()}
              disabled={updateCurrenciesLoading || createCurrenciesLoading || selectedCurrencyUpdate?.currency_code}
              loading={updateCurrenciesLoading || createCurrenciesLoading}
              bordered={false}
              options={currencyOptions}
              showError={!selectedCurrencyUpdate && formSubmitted && !selectedCurrency?.currency_code}
              errorName="a Currency"
              errorClassName="formError"
            />
          </div>
        </div>
        <div className="ant-col-md-24">
          <H3FormInput
            type="number"
            containerClassName="orgInputContainer create-category-input"
            labelClassName="orgFormLabel"
            inputClassName="orgFormInput"
            onChange={(event) => {
              setConversionRate(event.target.value);
            }}
            value={ConversionRate}
            label="Currency Conversion Rate"
            maxlength="10"
            required
            disabled={updateCurrenciesLoading || createCurrenciesLoading}
            loading={updateCurrenciesLoading || createCurrenciesLoading}
          />
          {formSubmitted && !ConversionRate && <div className="formError">*Please Fill the Currency Conversion Rate.</div>}
        </div>
        <div className="ant-col-md-24">
          <H3FormInput
            type="number"
            containerClassName="orgInputContainer create-category-input"
            labelClassName="orgFormLabel"
            inputClassName="orgFormInput"
            value={selectedCurrencyUpdate?.automatic_conversion_rate || selectedCurrency?.currency_conversion_rate}
            label="Automatic Currency Conversion Rate"
            maxlength="10"
            required
            disabled
            loading={updateCurrenciesLoading || createCurrenciesLoading}
          />
        </div>
      </div>
      <div className="custom-drawer__footer">
        <div className="ant-col-md-6">
          <H3Button
            buttonType={defaultButtonTypes.BLUE_ROUNDED}
            text={selectedCurrencyUpdate ? 'Update Currency' : 'Add Currency'}
            onClick={() => (selectedCurrencyUpdate ? UpdateCurrencies() : CreateCurrencies())}
            isLoading={createCurrenciesLoading || updateCurrenciesLoading}
            disabled={updateCurrenciesLoading || createCurrenciesLoading}
            style={{
              width: '180px',
              borderRadius: '5px',
              padding: '7px 0px',
              marginLeft: '0',
            }}
          />
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = ({ UserReducers, CurrenciesReducers }) => ({
  user: UserReducers.user,
  createCurrenciesLoading: CurrenciesReducers.createCurrenciesLoading,
  updateCurrenciesLoading: CurrenciesReducers.updateCurrenciesLoading,
});

const mapDispatchToProps = (dispatch) => ({
  createCurrencies: (payload, callback) => dispatch(CurrenciesActions.createCurrencies(payload, callback)),
  updateCurrencies: (payload, callback) => dispatch(CurrenciesActions.updateCurrencies(payload, callback)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CurrenciesForm));
